import { StyleSheet } from 'react-native';
import React, { useEffect, useState } from "react";
import _ from "lodash";
import ThemedModal from "components/atoms/ThemedModal";
import ThemedList from "components/atoms/ThemedList";
import ListItem from 'theme/ListItem';
import LoadingComponent from "components/atoms/Loading";
import FetchManagementBuilding from "utils/fetch/management/FetchManagementBuilding";
import Translate from "utils/translate";
import i18n from "utils/i18n";
import ThemedInputSearch from "components/atoms/ThemedInputSearch";
import EmployeeCard, { EmployeeCardModes } from "components/molecules/EmployeeCard";
import { useNavigation } from '@react-navigation/native'
import { ScannedInText } from 'components/atoms/EmployeeScan'
import HelperDate, { dateFormat } from 'utils/helper-date'

const ManagementDashboardModalMeetingRoomDetails = ( { building = null, onClose = null } ) => {
	const navigation = useNavigation();
	
	const [ isLoading, setIsLoading ] = useState( true );
	const [ scans, setScans ] = useState( [] );
	const [ searchValue, setSearchValue ] = useState( "" );

	useEffect( () => {
		FetchManagementBuilding.fetchScans({
			buildings: [ building.guid ],
			scanInAtDate: HelperDate.date().format( dateFormat.DATE + ' 00:00:01')+'_after_equal',
			bookingDate: [
				HelperDate.date().format( dateFormat.DATE_TIME ),
			],
			callbackStart: setIsLoading.bind( this, true ),
			callbackError: setIsLoading.bind( this, false ),
			/* TODO optimize */
			callbackSuccess: ( { buildings } ) => {
				const scans = [];
				_.forEach( buildings, ( building ) => {
					_.forEach( _.get( building, 'scans', [] ), ( scan ) => {
						let employee = _.get( scan, 'employee', {} );
						if( !_.isEmpty( employee ) ) {
							scans.push( scan );
						}
					});
				});
				
				setScans( [ ...scans ] );
				setIsLoading( false );
			},
		});
	}, [] );

	const title = i18n.t( 'management:pages.dashboard.titles.statistics', { name: Translate.field( building, 'title' ) } );

	let filteredScans = scans;
	if( searchValue.length > 0 ) {
		filteredScans = _.filter( scans, ( scan ) => {
			return _.includes(_.get(scan, ['employee', 'name'], '').toLowerCase(), searchValue);
		} );
	}
	
	let content = <LoadingComponent />
	if( !isLoading ) {
		content = (
			<ThemedList
				data={ filteredScans }
				dividerEnabled={true}
				renderItem={( {item = [] } ) => {
					return (
						<ListItem>
							<EmployeeCard
								mode={ EmployeeCardModes.listItem }
								navigation={ navigation }
								showHeart={ false }
								employee={ item.employee }
							>
								<ScannedInText
									item={ item }
								/>
							</EmployeeCard>
						</ListItem>
					);
				}}
			/>
		)
	}

	return (
		<ThemedModal
			visible={ true }
			setVisible={ onClose }
			title={ title }>
			
			<ThemedInputSearch
				onChangeText={  _.debounce( ( value ) => {
					return setSearchValue(value?.toLowerCase() ?? '');
				}, 400 ) }
				style={ staticStyles.themedInputSearchMarginTop10 }
			/>
			
			{ content }
		</ThemedModal>
	);
}

const staticStyles = StyleSheet.create({
	themedInputSearchMarginTop10: {
		marginTop: 10,
	},
});

export default ManagementDashboardModalMeetingRoomDetails;
